import { Base } from './base';

export class VehicleException extends Base {
    VehicleExceptionID?: string;
    AuthorID?: string;
    CompanyID?: number;
    PublicInstitutionID?: number;
    VehicleID?: string;
    CreateDate?: Date;
    Description?: string;
    FromDate?: Date;
    FullName?: string;
    Phone?: string;
    ToDate?: Date;

    // Model properties
    ModelAuthor?: string;
    ModelCompany?: string;
    ModelPublicInstitution?: string;
    VehiclePlate?: string;
}
